import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@root/shared/service/translate.service';
import { range } from 'lodash';

@Component({
  selector: 'widget-nights',
  templateUrl: './nights.component.html',
  styleUrls: ['./nights.component.scss'],
})
export class WidgetNightsComponent implements OnInit {
  @Input() value = {
    start: 1,
    end: -1,
  };

  @Output() valueChange = new EventEmitter();

  listOfNightsLeftOption: Option[] = range(1, 100).map((i) => ({
    label: `${i} ${this.t.select(['word.singular.night', 'word.plural.night'], null, i)}`,
    value: i,
  }));
  listOfNightsRightOption: Option[] = [
    ...this.listOfNightsLeftOption,
    // { label: `1 ${this.t.t('word.singular.night')}`, value: 1 },
    { label: `∞ ${this.t.t('word.plural.night')}`, value: -1 },
  ];

  constructor(private t: TranslateService) {}

  ngOnInit() {}

  onSelectNightStart(value) {
    setTimeout(() => {
      this.value.start = Math.min(value, this.value.end === -1 ? Number.MAX_VALUE : this.value.end);

      this.valueChange.emit(this.value);
    });
  }

  onSelectNightEnd(value) {
    /**
     * @fixme 为什么必须放在异步里面才能生效？
     */
    setTimeout(() => {
      this.value.end = value === -1 ? -1 : Math.max(value, this.value.start);
      console.log('after: nights: ', this.value);

      this.valueChange.emit(this.value);
      // this.cdr.detectChanges();
    });
  }
}
